import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LargeShareholderFormComponent } from '../large-shareholder-form/large-shareholder-form.component';
import { LargeShareholderService } from '../../../services/large-shareholder.service';
import { CreateLargeShareholderRequest } from '../../../models/api/createLargeShareholderRequest';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HotToastService } from '@ngxpert/hot-toast';
import { Helpers } from '../../../utilities/helpers';

@Component({
  selector: 'app-large-shareholder-create',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LargeShareholderFormComponent, NgxSpinnerModule],
  templateUrl: './large-shareholder-create.component.html',
  styleUrls: ['./large-shareholder-create.component.scss']
})
export class LargeShareholderCreateComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private largeShareholderService: LargeShareholderService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private toast: HotToastService
  ) {
    const currentYear = Helpers.defaultMeasurementYear();

    this.form = this.fb.group({
      year: [currentYear, Validators.required],
      fullName: ['', Validators.required],
      address: [''],
      website: [''],
      email: [''],
      country: [''],
      category: [''],
      subcategory: [''],
      notes: ['']
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.spinnerService.show();

      const formValue = this.form.value;
      const request: CreateLargeShareholderRequest = {
        year: parseInt(formValue.year),
        name: formValue.fullName,
        address: formValue.address || '',
        website: formValue.website || '',
        email: formValue.email || '',
        countryId: formValue.country?.id || formValue.country,
        categoryId: formValue.category?.id || formValue.category,
        subCategoryId: formValue.subcategory?.id || formValue.subcategory || '',
        notes: formValue.notes || ''
      };

      this.largeShareholderService.createLargeShareholder(request).subscribe({
        next: () => {
          this.spinnerService.hide();
          this.toast.success('Large shareholder created successfully', {
            iconTheme: {
              primary: 'var(--mat-sys-primary)',
              secondary: '#FFF',
            }
          });
          this.router.navigate(['/large-shareholders/list']);
        },
        error: (error: Error) => {
          this.spinnerService.hide();
          this.toast.error('Error creating large shareholder', {
            iconTheme: {
              primary: 'var(--mat-sys-error)',
              secondary: '#FFF',
            }
          });
          console.error('Error creating large-shareholder:', error);
        }
      });
    }
  }

  onCancel() {
    this.router.navigate(['/large-shareholders/list']);
  }
}
